var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckedRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#EB0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5836 10.3868C16.7945 10.1759 16.7945 9.83397 16.5837 9.62308C16.3728 9.4122 16.0309 9.41219 15.82 9.62307L11.3431 14.0998L9.32765 12.0843C9.11676 11.8735 8.77486 11.8735 8.56397 12.0843C8.35309 12.2952 8.35309 12.6371 8.56397 12.848L10.9611 15.2451C11.0608 15.3448 11.1898 15.3974 11.3204 15.4028C11.4661 15.4089 11.6138 15.3564 11.7251 15.2451L16.5836 10.3868Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckedRed);
export default __webpack_public_path__ + "static/media/icon_checked_red.9ba311ac5899349518994b619a954524.svg";
export { ForwardRef as ReactComponent };